// @flow
import React, { Component, lazy, Suspense } from "react";
import ReactDOM from "react-dom";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";
import RootRef from "@material-ui/core/RootRef";

import {
  isMomentBefore,
  isMomentAfter
} from "../../../global/functions/DateTimeAmend";
import ProjectCloseStatusLabel from "./ProjectCloseStatusLabel";
import { LoadingProgress, NoItem } from "imagus-components";

const ProjectItem = lazy((): * => import("./ProjectItem"));

type ProjectListStatesType = {
  expanded: null | string
};

type ProjectListPropsType = {
  projects: Array<*>,
  currentCompany?: { [key: string]: * },
  openSnackbar: Function,
  setActionError?: Function,
  isAdmin?: boolean,
  canViewQuotes?: boolean,
  preLoadId?: string,
  companyFilter?: Array<*>,
  dateStartFilter?: Date | null,
  dateEndFilter?: Date | null
};

class ProjectList extends Component<
  ProjectListPropsType,
  ProjectListStatesType
> {
  constructor(props: ProjectListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
    this.panelRefs = {};
  }

  setRef = (id: string): * => (ref: *): * => {
    this.panelRefs[id] = ref;
  };

  componentDidMount() {
    if (this.props.preLoadId) {
      this.setState(
        { expanded: this.props.preLoadId },
        (): * => {
          let ref = this.panelRefs[this.props.preLoadId];
          if (ref) {
            ref.scrollIntoView();
          }
        }
      );
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render(): * {
    const { expanded } = this.state;
    const projects = this.props.projects;
    const list =
      projects &&
      projects.map(
        (project: *, i: number): * => {
          let display = true;
          if (this.props.companyFilter && this.props.companyFilter.length > 0) {
            if (
              this.props.companyFilter.indexOf(project.createdCompany.id) < 0
            ) {
              display = false;
            }
          }
          if (this.props.dateStartFilter) {
            if (
              isMomentBefore(
                project.createDateOrigin,
                this.props.dateStartFilter
              )
            ) {
              display = false;
            }
          }
          if (this.props.dateEndFilter) {
            if (
              isMomentAfter(project.createDateOrigin, this.props.dateEndFilter)
            ) {
              display = false;
            }
          }
          if (display) {
            let createdByToggle =
              (this.props.currentCompany &&
                project.createdCompany.uuid !==
                  this.props.currentCompany.uuid) ||
              this.props.isAdmin;

            return (
              <RootRef rootRef={this.setRef(project.id)} key={project.id}>
                <ExpansionPanel
                  expanded={expanded === project.id}
                  onChange={this.handleChange(project.id)}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" className="heading">
                      <b>Project Name</b> {project.project_name}
                    </Typography>
                    <Typography variant="subtitle1" className="subheading">
                      <b>Created On</b> {project.createdDate}
                      {createdByToggle && (
                        <span>
                          {" "}
                          <b>By</b> {project.createdCompany.name}
                        </span>
                      )}
                    </Typography>
                    <Typography variant="subtitle1" className="heading">
                      {project.createdCompany.companyType === "RESELLER" ? (
                        <span>
                          <b>End User</b>{" "}
                          {project.enduserCompany &&
                            project.enduserCompany.name}
                        </span>
                      ) : (
                        <span>
                          <b>Reseller</b>{" "}
                          {project.resellerCompany &&
                            project.resellerCompany.name}
                        </span>
                      )}
                      <ProjectCloseStatusLabel
                        outcome={project.outcome}
                        labelClass="left-margin-15"
                      />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Suspense fallback={<LoadingProgress />}>
                      {expanded === project.id && (
                        <ProjectItem
                          project={project}
                          openSnackbar={this.props.openSnackbar}
                          setActionError={this.props.setActionError}
                          isAdmin={this.props.isAdmin}
                          canViewQuotes={this.props.canViewQuotes}
                        />
                      )}
                    </Suspense>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </RootRef>
            );
          } else {
            return null;
          }
        }
      );

    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {(list.filter(item => item !== null).length === 0 && (
              <NoItem content="No Project has found." />
            )) ||
              list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default ProjectList;
